export default __webpack_public_path__ + "static/media/photo1.ed0bd980.jpg";